import LoaderStrings from 'LoaderStrings';
export default LoaderStrings.ConferenceLinks;
